export default __webpack_public_path__ + "static/media/play-str.4c94c839.svg";